import { get } from '@rails/request.js'

// eslint-disable-next-line camelcase
export default function bid__description_component(props) {
  const URL_REGEXP = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+~#?&/=]*)/g

  return {
    truncated: true,
    descriptionSeenTracked: false,
    linkVisitedTracked: false,

    text: {
      'x-html': 'description'
    },
    showMore: {
      'x-show': 'truncated && descriptionTooLong',
      '@click.prevent': 'expand'
    },
    showLess: {
      'x-show': '!truncated && descriptionTooLong',
      '@click.prevent': 'collapse'
    },

    get descriptionTooLong() {
      return props.description.length > props.threshold
    },
    get description() {
      const description = this.truncated ? props.description.substr(0, props.threshold) : props.description
      return props.linkify ? this.linkify(description) : description
    },
    linkify(string) {
      return string.replaceAll(URL_REGEXP, match => {
        return `<a href="${
          match.startsWith('http') ? match : `https://${match}`
        }" target="_blank" @click.prevent="trackAndOpenLink">${match}</a>`
      })
    },

    expand() {
      this.trackDescriptionSeen()
      this.truncated = false
    },

    collapse() {
      this.truncated = true
    },

    trackDescriptionSeen() {
      if (this.descriptionSeenTracked || !props.description_seen_url) return
      this.descriptionSeenTracked = true

      get(props.description_seen_url)
    },

    trackLinkVisited() {
      if (this.linkVisitedTracked || !props.link_visited_url) return
      this.linkVisitedTracked = true

      get(props.link_visited_url)
    },

    trackAndOpenLink(event) {
      event.preventDefault()
      this.trackLinkVisited()
      window.open(event.target.href, '_blank')
    }
  }
}
